<template>
  <div flat class="h-100 w-100">
    <b-row no-gutters class="pa-3 h-100 justify-content-between">
      <div
        :style="`${hideHdrMode ? 'width:5%' : 'width:30%'}`"
        class="h-100 hideHdr"
      >
        <div v-if="!hideHdrMode" class="w-100 h-100">
          <b-row no-gutters align-v="center" class="justify-content-between">
            <b-col cols="1">{{ t.t(dictEnum.LBL_Company) }}</b-col>
            <b-col cols="3">
              <b-form-select v-model="company" @change="changeCompList">
                <!-- @change="" -->
                <!-- <option value="" selected="selected">
                  {{ t.t(dictEnum.LBL_SelectAll) }}
                </option> -->
                <option
                  v-for="(comp, index) in compList"
                  :key="index"
                  :value="comp.CompCode"
                >
                  {{ user.Lang == "EN" ? comp.EName : comp.CName }}
                </option>
              </b-form-select>
            </b-col>
            <b-col cols="1" class="pl-3">{{ t.t(dictEnum.LBL_Status) }}</b-col>
            <b-col cols="3">
              <b-form-select v-model="trialStatus" @change="getPayrollHdrList">
                <!-- <option value="All" selected="selected">
                  {{ t.t(dictEnum.LBL_SelectAll) }}
                </option> -->
                <option
                  v-for="(status, statusIndex) in trialStatusList"
                  :key="statusIndex"
                  :value="status.id"
                >
                  {{ status.value }}
                </option>
              </b-form-select>
            </b-col>
            <b-col cols="3" class="text-right">
              <img
                width="15px"
                src="../../../../../static/images/Vector.png"
                style="cursor:pointer"
                @click="clickHideHdr()"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="h-90 pt-3">
            <div class="tab-content bg-white w-100">
              <div class="tab-pane active table-responsive color-table">
                <b-table
                  :items="trialList"
                  :fields="trialField"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :tbody-tr-class="rowClass"
                  @row-clicked="OnPayrollTrialSelect"
                >
                  <template #head(DateVal)>
                    <div class="text-center">
                      {{ t.t(dictEnum.LBL_Month) }}
                    </div>
                  </template>
                  <template #cell(DateVal)="data">
                    <div class="text-center">
                      {{ data.item.DateVal | moment(Settings.DateTime.yyyymm) }}
                    </div>
                  </template>
                  <template #head(TimeBetween)>
                    <div class="text-center">
                      {{ t.t(dictEnum.LBL_Date) }}
                    </div>
                  </template>
                  <template #cell(TimeBetween)="data">
                    <div class="text-center">
                      {{
                        data.item.PayDateFrom
                          | moment(Settings.DateTime.yyyymmdd)
                      }}
                      -
                      {{
                        data.item.PayDateTo | moment(Settings.DateTime.yyyymmdd)
                      }}
                    </div>
                  </template>
                  <template #head(TotAmt)>
                    <div class="text-right">
                      {{ t.t(dictEnum.LBL_Salary) }}
                    </div>
                  </template>
                  <template #cell(TotAmt)="data">
                    <div class="text-right">
                      {{ data.item.TotAmt | toFixedDecimal }}
                    </div>
                  </template>
                  <template #cell(PayGrpCode)="data">
                    {{ PayGroupName(data.item.PayGrpCode) }}
                  </template>
                  <template #cell(Status)="data">
                    {{ StatusName(data.item.Status) }}
                  </template>
                </b-table>
              </div>
            </div>
          </b-row>
          <b-row no-gutters class="pt-3" v-if="trialList.length > 0">
            <b-col cols="2">
              <b-pagination
                first-number
                last-number
                limit="10"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="trialList.length"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div v-else class="w-100 h-100">
          <b-row no-gutters align-v="center" class="justify-content-between">
            <b-col cols="12" class="text-right">
              <img
                width="15px"
                src="../../../../../static/images/up-right-and-down-left-from-center-solid 2.png"
                style="cursor:pointer"
                @click="clickHideHdr()"
              />
            </b-col>
          </b-row>
          <b-row no-gutters class="h-80 pt-3">
            <div class="tab-content bg-white w-100">
              <div class="tab-pane active table-responsive color-table">
                <b-table
                  :items="trialList"
                  :fields="hideTrialField"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :tbody-tr-class="rowClass"
                  @row-clicked="OnPayrollTrialSelect"
                >
                  <template #cell(DateVal)="data">
                    <div class="text-right">
                      {{
                        data.item.DateVal | moment(Settings.DateTime.yyyymmdd)
                      }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </b-row>
        </div>
      </div>
      <div
        :style="`${hideHdrMode ? 'width:95%' : 'width:70%'}`"
        class="h-100 pl-5 hideHdr"
      >
        <b-row no-gutters align-v="center">
          <b-col cols="1">{{ t.t(dictEnum.LBL_Month) }}</b-col>
          <b-col cols="2" class="pr-3 ">
            <date-picker
              id="dpRoster"
              v-model="selectedRecord.DateVal"
              :lang="lang"
              type="month"
              format="MM/YYYY"
              :disabled="editMode"
              v-bind:clearable="false"
            ></date-picker>
          </b-col>
          <b-col cols="1">
            {{ DateBetween(selectedRecord) }}
          </b-col>
          <b-col cols="1" class="pr-1">{{ t.t(dictEnum.LBL_PayGroup) }}</b-col>
          <b-col cols="2">
            <b-form-select v-model="selectedRecord.PayGrpCode" size="sm">
              <option
                v-for="(payGrp, payGrpIndex) in payGroupList"
                :key="payGrpIndex"
                :value="payGrp.Grp"
              >
                {{ payGrp.GrpDesc }}
              </option>
            </b-form-select>
          </b-col>
          <b-col cols="2" class="pl-2 pr-2">
            {{ TotalActual() | toFixedDecimal }}/{{
              TotalCopeWith() | toFixedDecimal
            }}
          </b-col>
          <b-col cols="3" class="d-flex justify-content-end">
            <!-- <button
              v-if="
                hasRight(Settings.Permission.Change, menuId) &&
                  selectedRecord.Status == Settings.PayrollStatus.New
              "
              class="approve btn btn-primary waves-effect waves-light"
              @click="submitPayTrial()"
            >
              {{ t.t(dictEnum.LBL_Send) }}
            </button> -->
            <button
              v-if="
                hasRight(Settings.Permission.Change) &&
                  selectedRecord.Status == Settings.PayrollStatus.Approving
              "
              class="approve btn btn-primary waves-effect waves-light mr-2"
              @click="ApprovelItems()"
            >
              {{ t.t(dictEnum.LBL_Approve) }}
            </button>
            <button
              v-if="
                hasRight(Settings.Permission.Change) &&
                  selectedRecord.Status == Settings.PayrollStatus.Approving
              "
              class="approve btn btn-danger waves-effect waves-light"
              @click="RejectlItems"
            >
              {{ t.t(dictEnum.LBL_Reject) }}
            </button>
            <button
              v-if="
                hasRight(Settings.Permission.Export) &&
                  selectedRecord.Status == Settings.PayrollStatus.Approved
              "
              class="approve btn btn-primary waves-effect waves-light mr-2"
              @click="ExportItems()"
            >
              {{ t.t(dictEnum.BTN_Export) }}
            </button>
            <!-- <button
              v-if="
                hasRight(Settings.Permission.Print) &&
                  selectedRecord.Status == Settings.PayrollStatus.Approved
              "
              class="approve btn btn-info waves-effect waves-light mr-2"
              @click="PrintItems"
            >
              {{ t.t(dictEnum.LBL_Print) }}
            </button> -->
            <button
              v-if="
                hasRight(Settings.Permission.Change) &&
                  selectedRecord.Status == Settings.PayrollStatus.Approved
              "
              class="approve btn btn-danger waves-effect waves-light"
              @click="EndItems"
            >
              {{ t.t(dictEnum.LBL_End) }}
            </button>
          </b-col>
        </b-row>
        <b-row
          no-gutters
          class="w-100 btn-message mt-3"
          style="min-height:40px"
        >
          <b-btn
            v-if="messageList.length > 0"
            pill
            class="ma-1 ellipsis"
            @click="showTrialMessage"
          >
            <font-awesome-icon icon="question-circle" />
            {{
              messageList[0].Notes
                ? messageList[0].Notes
                : t.t(dictEnum.LBL_Msg)
            }}
          </b-btn>
        </b-row>
        <div class="h-90 w-100" style="overflow-y: auto;">
          <div
            class="trialByDept w-100"
            v-for="(DeptItem, DeptItemIndex) in payrollTrialDetail"
            :key="DeptItemIndex"
          >
            <b-row no-gutters class="trialByDept_head">
              <b-col cols="4">
                <div>
                  {{ DeptItem.Dept }} (
                  {{ ActualPayment(DeptItem) | toFixedDecimal }}/{{
                    CopeWith(DeptItem) | toFixedDecimal
                  }})
                </div>
                <span class="bdr bg-image-rainbow"></span>
              </b-col>
            </b-row>
            <div no-gutters class="w-100" style="overflow-x:auto">
              <table class="trialByDept_table">
                <thead>
                  <tr>
                    <th>
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th>
                      {{ t.t(dictEnum.LBL_Name) }}
                    </th>
                    <th class="text-center">
                      {{ t.t(dictEnum.LBL_DateJoin) }}
                    </th>
                    <th>
                      {{ t.t(dictEnum.LBL_StaffType) }}
                    </th>
                    <th class="text-right">
                      {{ t.t(dictEnum.LBL_Rate) }}
                    </th>
                    <th class="text-right">x {{ t.t(dictEnum.LBL_Number) }}</th>
                    <th class="text-right">= {{ t.t(dictEnum.LBL_Salary) }}</th>
                    <th class="text-right">
                      + {{ t.t(dictEnum.LBL_StaffFixAlw) }}
                    </th>
                    <th class="text-right">
                      + {{ t.t(dictEnum.LBL_SpecialPayment) }}
                    </th>
                    <th class="text-right">
                      - {{ t.t(dictEnum.LBL_NoPayLvs) }}
                    </th>
                    <th
                      class="text-right"
                      style="cursor:pointer"
                      @click="AdditionItemShow(DeptItem)"
                    >
                      + {{ t.t(dictEnum.LBL_Addition) }}
                    </th>
                    <th
                      class="text-right"
                      v-show="DeptItem.additionShow"
                      v-for="(AddItem, AddItemIndex) in DeptItem.AddHeads"
                      :key="`Add-${DeptItemIndex}-${AddItemIndex}`"
                    >
                      {{ AddItem }}
                    </th>
                    <th
                      class="text-right"
                      style="cursor:pointer"
                      @click="DeductItemShow(DeptItem)"
                    >
                      - {{ t.t(dictEnum.LBL_Deduct) }}
                    </th>
                    <th
                      class="text-right"
                      v-show="DeptItem.deductShow"
                      v-for="(DeductItem, DeductIndex) in DeptItem.DeductHeads"
                      :key="`Deduct-${DeptItemIndex}-${DeductIndex}`"
                    >
                      {{ DeductItem }}
                    </th>
                    <th class="text-right">= {{ t.t(dictEnum.LBL_Total) }}</th>
                    <th class="text-right">- {{ t.t(dictEnum.LBL_VCE) }}</th>
                    <th class="text-right">- {{ t.t(dictEnum.LBL_MPFe) }}</th>
                    <th class="text-right">= {{ t.t(dictEnum.LBL_Net) }}</th>
                    <th class="text-right">
                      {{ t.t(dictEnum.LBL_MPFr) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tableItem, ItemIndex) in DeptItem.Details"
                    :key="ItemIndex"
                    @click="selectedAppr(tableItem)"
                    @contextmenu.prevent="showOnlyApp(tableItem)"
                    :class="{
                      'selected-tr':
                        ApproveOrRejectList.map(x => x.Id).indexOf(
                          tableItem.Id
                        ) != -1,
                      'approve-tr':
                        tableItem.Status == Settings.PayrollStatus.Approved,
                      'reject-tr':
                        tableItem.Status == Settings.PayrollStatus.Rejected
                    }"
                  >
                    <td>
                      {{ tableItem.Id }}
                    </td>
                    <td>
                      {{ tableItem.Name }}
                    </td>
                    <td>
                      {{
                        tableItem.DateJoin | moment(Settings.DateTime.yyyymmdd)
                      }}
                    </td>
                    <td>{{ tableItem.Type }}</td>
                    <td class="text-right">
                      {{ tableItem.Basic | toFixedDecimal }}
                    </td>
                    <td class="text-right">{{ tableItem.xQty }}</td>
                    <td class="text-right">
                      {{ tableItem.Salary | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ tableItem.StaffFixAlw | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ tableItem.Prepaid | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ tableItem.NoPayLeave | toFixedDecimal(3) }}
                    </td>
                    <td
                      class="text-right"
                      @click="AdditionItemShow(DeptItem)"
                      style="cursor:pointer"
                    >
                      {{ DeptItem.Salary }}
                      {{
                        CountNumber(tableItem.AddWages, "Amt") | toFixedDecimal
                      }}
                    </td>
                    <td
                      class="text-right"
                      v-show="DeptItem.additionShow"
                      v-for="(addHead, headIndex) in DeptItem.AddHeads"
                      :key="`AddDtl-${DeptItemIndex}-${headIndex}`"
                      @dblclick="showAdjustmentClick(tableItem)"
                    >
                      <div
                        v-for="(wage, wageIndex) in tableItem.AddWages"
                        :key="wageIndex"
                      >
                        {{
                          wage.Particulars == addHead
                            ? wage.Amt
                            : 0 | toFixedDecimal
                        }}
                      </div>
                    </td>
                    <td
                      class="text-right"
                      style="cursor:pointer"
                      @click="DeductItemShow(DeptItem)"
                    >
                      {{
                        CountNumber(tableItem.DeductWages, "Amt")
                          | toFixedDecimal
                      }}
                    </td>
                    <td
                      class="text-right"
                      v-show="DeptItem.deductShow"
                      v-for="(deductHead, headIndex) in DeptItem.DeductHeads"
                      :key="`DeductDtl-${DeptItemIndex}-${headIndex}`"
                      @dblclick="showAdjustmentClick(tableItem)"
                    >
                      <div
                        v-for="(wage, wageIndex) in tableItem.DeductWages"
                        :key="wageIndex"
                      >
                        {{
                          wage.Particulars == deductHead
                            ? wage.Amt
                            : 0 | toFixedDecimal
                        }}
                      </div>
                    </td>
                    <td class="text-right">
                      {{ tableItem.Total | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ tableItem.VC | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ tableItem.MPF | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ Netprofit(tableItem) | toFixedDecimal }}
                    </td>
                    <td class="text-right">
                      {{ tableItem.EmployerMPF | toFixedDecimal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <b-modal
      id="messageShow"
      :title="t.t(dictEnum.LBL_Msg)"
      :ok-title="t.t(dictEnum.BTN_OK)"
      ok-only
      size="lg"
    >
      <b-row no-gutters>
        <b-form-textarea
          class="ml-2 mr-2 mb-3"
          readonly
          v-model="selectedMsg.Notes"
        ></b-form-textarea>
      </b-row>
      <b-row no-gutters>
        <div class="pl-3 pr-3 w-100">
          <table class="w-100 popupTable">
            <tr class="head">
              <th>{{ t.t(dictEnum.MENU_Employees) }}</th>
              <th style="width: 45%">{{ t.t(dictEnum.LBL_Msg) }}</th>
              <th>{{ t.t(dictEnum.LBL_Approval) }}</th>
              <th>{{ t.t(dictEnum.LBL_ApproveBy) }}</th>
            </tr>
            <tr
              v-for="(msg, msgIndex) in messageList"
              :key="msgIndex"
              @click="clickMsg(msg)"
            >
              <td>{{ msg.StfID }} {{ msg.StfName }}</td>
              <td class="ellipsis">{{ msg.Notes }}</td>
              <td>
                <div v-if="msg.Aprv">
                  <img
                    width="20px"
                    src="../../../../../static/images/green tick.png"
                  />
                </div>
                <div v-else>
                  <img
                    width="20px"
                    src="../../../../../static/images/red cancel.png"
                  />
                </div>
              </td>
              <td>
                {{ msg.AddBy }} @
                {{ msg.DateAdd | moment(Settings.DateTime.yyyymmddhhmm) }}
              </td>
            </tr>
          </table>
        </div>
      </b-row>
    </b-modal>
    <b-modal
      id="adjustmentShow"
      :title="t.t(dictEnum.LBL_PayrollAdjustment)"
      :ok-title="t.t(dictEnum.BTN_OK)"
      ok-only
    >
      <b-row no-gutters class="pl-3 pr-3">
        <b-col cols="5"> {{ selectedDtl.Id }} {{ selectedDtl.Name }} </b-col>
        <b-col cols="7">
          <b-row no-gutters>
            <b-col
              cols="6"
              v-for="(adjustmentType, adjustmentIndex) in AdjustmentTypeList"
              :key="adjustmentIndex"
            >
              <b-form-checkbox
                v-model="AdjustmentChk"
                :value="adjustmentType.id"
              >
                {{ adjustmentType.value }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <div class="pl-3 pr-3 w-100">
          <table class="w-100 popupTable">
            <tr class="head">
              <th
                v-for="(AdjTH, AdjThIndex) in AdjustmentTHs"
                :key="AdjThIndex"
                :class="AdjTH.class"
                @click="sortByAdjustment(AdjTH.id)"
              >
                <div class="d-flex align-center">
                  {{ AdjTH.label }}
                </div>
              </th>
            </tr>
            <tr
              v-for="(adjustmentItem, adjustmentIndex) in AdjustmentsList"
              :key="adjustmentIndex"
            >
              <td class="text-center">
                {{ adjustmentItem.DateTx | moment(Settings.DateTime.yyyymmdd) }}
              </td>
              <td>{{ adjustmentItem.Particulars }}</td>
              <td>{{ adjustmentItem.AdjAdd ? "+" : "-" }}</td>
              <td class="text-right">
                {{ adjustmentItem.Amt | toFixedDecimal }}
              </td>
              <td>
                {{
                  adjustmentItem.SysGen
                    ? t.t(dictEnum.LBL_System)
                    : t.t(dictEnum.LBL_Manual)
                }}
              </td>
            </tr>
          </table>
        </div>
      </b-row>
      <b-row no-gutters class="pl-3 pr-3 justify-content-end">
        {{ t.t(dictEnum.LBL_Net) }} : {{ CountAdjuctment() | toFixedDecimal }}
      </b-row>
    </b-modal>
    <b-modal id="onlyApproval" :title="`${selectedDtl.Id} ${selectedDtl.Name}`">
      <template #modal-footer="{ hide }">
        <b-button size="sm" variant="outline-secondary" @click="hide()">
          {{ t.t(dictEnum.BTN_Cancel) }}
        </b-button>
        <!-- <b-button size="sm" variant="success" @click="ApproveOrReject(true)">
          {{ t.t(dictEnum.LBL_Approve) }}
        </b-button> -->
        <b-button size="sm" variant="danger" @click="ApproveOrReject(false)">
          {{ t.t(dictEnum.LBL_Reject) }}
        </b-button>
      </template>

      <b-row no-gutters class="pl-3 pr-3">
        <b-form-textarea
          v-model="selectedDtl.Msg"
          :placeholder="t.t(dictEnum.CFM_Reject)"
          rows="8"
        ></b-form-textarea>
      </b-row>
    </b-modal>
    <b-modal
      id="PrintModal"
      :title="t.t(dictEnum.LBL_Print)"
      :ok-title="t.t(dictEnum.BTN_Confirm)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="PrintTableData"
    >
      <b-row
        align-v="center"
        class="pl-5 pt-3"
        no-gutters
        v-for="(type, typeIndex) in PrintType"
        :key="typeIndex"
      >
        <b-form-checkbox v-model="chxPrintType" :value="type.id">
          {{ type.value }}
        </b-form-checkbox>
      </b-row>
    </b-modal>
    <b-modal
      id="ApprovalORRejectModalList"
      :title="AprORejBol ? t.t(dictEnum.LBL_Approve) : t.t(dictEnum.LBL_Reject)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      :ok-title="t.t(dictEnum.BTN_Confirm)"
      @ok="ApprOnlyDtl"
    >
      <b-row
        no-gutters
        class="pl-2 pr-2 pb-2"
        v-if="ApproveOrRejectList.length == 0"
      >
        {{ selectedRecord.DateVal | moment(Settings.DateTime.yyyymm) }}
      </b-row>
      <b-row no-gutters class="pl-2 pr-2">
        <b-form-textarea
          outlined
          id="Msg"
          v-model="selectedDtl.Msg"
          v-validate="'required'"
          required
          rows="8"
        ></b-form-textarea>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../../constants/Settings";
import { PayrollTrial } from "@/model/PayrollTrial";
import { datePickerLang } from "@/constants/globalConstants";
import PayGroupService from "@/service/PayGroupService";
import ArrayHelper from "../../../../common/helper/ArrayHelper";
import PayrollTrialService from "../../../../service/PayrollTrialService";
import SweetAlertService from "../../../../service/SweetAlertService";
import CompanyService from "@/service/CompanyService";
export default {
  name: "PayTrialApproval",
  components: {
    DatePicker,
    moment
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    editMode() {
      return this.selectMode == "Edit";
    },
    AdjustmentsList() {
      const chk = this.AdjustmentChk;
      let list = this.AdjustmentItemList;
      const reverse = this.reverse;
      const sortKey = this.sortKey;
      let Datas = [];
      let SystemList = [],
        ManualList = [];
      if (chk.indexOf("Add") > -1) {
        const Data = list.filter(x => x.AdjAdd);
        Datas = Datas.concat(Data);
      }
      if (chk.indexOf("Deduct") > -1) {
        const Data = list.filter(x => !x.AdjAdd);
        Datas = Datas.concat(Data);
      }
      Datas = ArrayHelper.uniqueBykey(Datas, "DateTx");

      if (chk.indexOf("System") > -1) {
        SystemList = Datas.filter(x => x.SysGen);
      }
      if (chk.indexOf("Manual") > -1) {
        ManualList = Datas.filter(x => !x.SysGen);
      }
      Datas = SystemList.concat(ManualList);
      ArrayHelper.sortByKey(Datas, sortKey, reverse);
      return Datas;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.PayrollApproval,
      Settings: Settings,
      dictEnum: dictEnum,
      lang: datePickerLang,
      compList: [],
      company: "",
      columnsExport: {
        StaffID: "StaffID",
        Name: "Name",
        DateJoin: "DateJoin",
        StaffType: "StaffType",
        Rale: "Rale",
        xNumber: "xNumber",
        Salary: "Salary",
        Addition: "Addition",
        Deduct: "Deduct",
        Total: "Total",
        VCE: "VCE",
        MPF: "MPF",
        Net: "Net",
        MPFR: "MPFR"
      },
      hideHdrMode: false,
      trialStatus: "All",
      trialStatusList: [
        {
          id: Settings.PayrollStatus.New,
          value: t.t(dictEnum.LBL_New)
        },
        {
          id: Settings.PayrollStatus.Approving,
          value: t.t(dictEnum.LBL_Pending)
        },
        {
          id: Settings.PayrollStatus.Approved,
          value: t.t(dictEnum.LBL_Approved)
        },
        {
          id: Settings.PayrollStatus.Released,
          value: t.t(dictEnum.LBL_Released)
        },
        {
          id: Settings.PayrollStatus.Closed,
          value: t.t(dictEnum.LBL_Closed)
        },
        {
          id: Settings.PayrollStatus.Rejected,
          value: t.t(dictEnum.LBL_Rejected)
        }
      ],
      selectedRecord: {},
      trialList: [],
      trialField: [
        {
          key: "DateVal",
          label: t.t(dictEnum.LBL_Month)
        },
        {
          key: "TimeBetween",
          label: t.t(dictEnum.LBL_Date)
        },
        {
          key: "TotAmt",
          label: t.t(dictEnum.LBL_Salary)
        },
        {
          key: "PayGrpCode",
          label: t.t(dictEnum.LBL_PayGroup)
        },
        {
          key: "Status",
          label: t.t(dictEnum.LBL_Status)
        }
      ],
      hideTrialField: [
        {
          key: "DateVal",
          label: t.t(dictEnum.LBL_Month)
        }
      ],
      currentPage: 1,
      perPage: 15,
      modelList: {
        edit: "Edit",
        view: "View"
      },
      selectMode: "View",
      payGroupList: [],
      payrollTrialDetail: [],
      showTrialDtl: [],
      messageShow: false,
      messageList: [],
      selectedMsg: {},
      reverse: false,
      sortKey: "",
      AdjustmentTHs: [
        {
          id: "DateTx",
          label: t.t(dictEnum.LBL_Date),
          class: "text-center"
        },
        {
          id: "Particulars",
          label: t.t(dictEnum.LBL_Particular),
          class: ""
        },
        {
          id: "AdjAdd",
          label: "+/-",
          class: ""
        },
        {
          id: "Amt",
          label: t.t(dictEnum.LBL_Amount),
          class: "text-right"
        },
        {
          id: "SysGen",
          label: t.t(dictEnum.LBL_Src),
          class: ""
        }
      ],
      AdjustmentChk: [],
      AdjustmentTypeList: [],
      AdjustmentItemList: [],
      ApproveOrRejectList: [],
      AprORejBol: false,
      chxPrintType: [],
      PrintType: [
        {
          id: "Bank",
          value: t.t(dictEnum.LBL_BankAutopay)
        },
        {
          id: "MPF",
          value: t.t(dictEnum.LBL_MPF)
        }
      ],
      selectedDtl: {
        Msg: ""
      }
    };
  },

  mounted() {
    this.assignRights();
    this.getPayGroupList();
    this.getPayrollHdrList();
    this.getCompList();
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (
        item.TxNum == this.selectedRecord.TxNum &&
        item.Status == this.selectedRecord.Status
      ) {
        return "selected-tr";
      }
    },

    Netprofit(item) {
      let num = 0;
      num = item.Total - item.MPF - item.VC;
      return num;
    },

    ActualPayment(item) {
      let num = 0;
      item.Details.forEach(x => {
        num = num + this.Netprofit(x);
      });
      return num;
    },

    TotalActual() {
      let num = 0;
      if (this.showTrialDtl.length > 0) {
        this.showTrialDtl.forEach(x => {
          num = num + this.ActualPayment(x);
        });
      }
      return num;
    },

    CopeWith(item) {
      let num = 0;
      item.Details.forEach(x => {
        num = num + this.Netprofit(x) + x.EmployerMPF;
      });
      return num;
    },

    TotalCopeWith() {
      let num = 0;
      if (this.showTrialDtl.length > 0) {
        this.showTrialDtl.forEach(x => {
          num = num + this.CopeWith(x);
        });
      }
      return num;
    },

    initData() {
      this.selectMode = this.modelList.view;
      this.selectedRecord = {};
      this.ApproveOrRejectList = [];
      this.currentPage = 1;
      this.AprORejBol = false;
      this.payrollTrialDetail = [];
      this.showTrialDtl = [];
    },

    DateBetween(item) {
      if (item) {
        let startDay = moment(item.PayDateFrom)
          .startOf("month")
          .format("DD/MM");
        let endDay = moment(item.PayDateTo)
          .endOf("month")
          .format("DD/MM");
        return `${startDay} - ${endDay}`;
      }
    },

    CountNumber(list, key) {
      let number = list.reduce((prev, cur) => {
        return prev + cur[key];
      }, 0);
      return number ? number : 0;
    },

    PayGroupName(payGroupId) {
      const find = this.payGroupList.find(x => x.Grp == payGroupId);
      if (find) {
        return find.GrpDesc;
      }
    },

    StatusName(statusID) {
      const find = this.trialStatusList.find(x => x.id == statusID);
      if (find) {
        return find.value;
      }
    },

    async getPayGroupList() {
      var obj = {};
      const response = await PayGroupService.getAllPayGroup(obj);
      if (response.data.IsSuccess) {
        this.payGroupList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getPayrollHdrList() {
      var obj = {
        payrollComp: this.company,
        status: this.trialStatus
      };
      const response = await PayrollTrialService.getPayrollHdrList(obj);
      if (response.data.IsSuccess) {
        ArrayHelper.sortByKey(response.data.Data, "DateVal", false);
        this.trialList = response.data.Data;
        this.initData();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getCompList() {
      var obj = {
        take: 100,
        skip: 0
      };
      const response = await CompanyService.getAllCompanyList(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data.Item1;
        this.comp = response.data.Data.Item1[0].CompCode || "";
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async changeCompList() {
      await this.getPayrollHdrList();
      if (this.company === "") {
        this.showTrialDtl = this.payrollTrialDetail;
        return;
      }
      this.showTrialDtl = this.payrollTrialDetail.map(item => {
        return {
          ...item,
          Details: item.Details.filter(
            cItem =>
              cItem.Id.toLowerCase().indexOf(this.company.toLowerCase()) === 0
          )
        };
      });
    },

    updateMode(mode) {
      this.selectMode = mode;
    },

    addPayrollTrial() {
      this.selectedRecord = new PayrollTrial();
      this.updateMode(this.modelList.edit);
    },

    editPayrollTrial() {
      this.updateMode(this.modelList.edit);
    },

    AdditionItemShow(item) {
      item.additionShow = !item.additionShow;
    },

    DeductItemShow(item) {
      item.deductShow = !item.deductShow;
    },

    clickHideHdr() {
      this.hideHdrMode = !this.hideHdrMode;
    },

    async deletePayrollTrial() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.LBL_Delete)}?`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        this.getPayrollHdrList();
      }
    },

    async PrintTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        return this.tableData;
      }
    },

    async submitPayTrial() {
      const obj = {
        txNum: this.selectedRecord.TxNum
      };
      const response = await PayrollTrialService.sendPayrollTrialItem(obj);
      if (response.data.IsSuccess) {
        this.getPayrollHdrList();
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async ApprovelItems() {
      this.$bvModal.show("ApprovalORRejectModalList");
      this.AprORejBol = true;
    },

    RejectlItems() {
      this.$bvModal.show("ApprovalORRejectModalList");
      this.AprORejBol = false;
    },

    selectedAppr(item) {
      const find = this.ApproveOrRejectList.find(x => x.Id == item.Id);
      if (!find) {
        this.ApproveOrRejectList.push(item);
      } else {
        this.ApproveOrRejectList = this.ApproveOrRejectList.filter(
          x => x.Id != item.Id
        );
      }
    },

    async ExportItems() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        let list = [];
        console.log(showTrialDtl, "--------showTrialDtl");
        for (const data of this.showTrialDtl) {
          list = list.concat(data.Details);
        }
        list.forEach(x => {
          x.DateJoin = moment(x.DateJoin).format(Settings.DateTime.yyyymmdd);
        });
        var XLSX = require("xlsx");
        var worksheet = XLSX.utils.json_to_sheet(list, false);
        let workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet);
        XLSX.writeFile(
          workbook,
          "PayrollTrial" +
            "_" +
            moment().format(Settings.DateTime.yyyymmddhhmmss) +
            ".xlsx"
        );
      }
    },

    PrintItems() {
      this.$bvModal.show("PrintModal");
    },

    async EndItems() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.MSG_AreSureEndPayroll)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
      }
    },

    async OnPayrollTrialSelect(item) {
      item.DateVal = moment(item.DateVal).format(Settings.DateTime.yyyymm);
      this.selectedRecord = item;
      let obj = {
        txNum: this.selectedRecord.TxNum
      };
      const response = await PayrollTrialService.getPayrollTrialDtl(obj);
      if (response.data.IsSuccess) {
        response.data.Data.forEach(x => {
          x.additionShow = false;
          x.deductShow = false;
          let addList = [],
            deductList = [];
          for (const detail of x.Details) {
            addList = addList.concat(detail.AddWages);
          }
          if (addList.length > 0) {
            x.AddHeads = addList.map(w => w.Particulars);
          }
          for (const detail of x.Details) {
            deductList = deductList.concat(detail.DeductWages);
          }
          if (deductList.length > 0) {
            x.DeductHeads = deductList.map(w => w.Particulars);
          }
        });
        this.payrollTrialDetail = response.data.Data;
        this.showTrialDtl = response.data.Data;
        this.updateMode(this.modelList.view);
        this.ApproveOrRejectList = [];
        this.getTrialMessage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    showOnlyApp(dtl) {
      if (dtl.Status == Settings.PayrollStatus.Approving) {
        this.selectedDtl = dtl;
        this.$bvModal.show("onlyApproval");
      }
    },

    async showTrialMessage() {
      this.$bvModal.show("messageShow");
      this.selectedMsg = this.messageList[0];
    },

    async getTrialMessage() {
      if (!this.selectedRecord.TxNum) return;
      const obj = {
        txNum: this.selectedRecord.TxNum
      };
      const response = await PayrollTrialService.getPayrollTrialMsg(obj);
      if (response.data.IsSuccess) {
        this.messageList = response.data.Data;
        this.selectedMsg = {};
        ArrayHelper.sortByKey(this.messageList, "DateAdd", false);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async ApproveOrReject(bol) {
      const obj = {
        staffIDs: [this.selectedDtl.Id],
        txNum: this.selectedRecord.TxNum,
        remark: this.selectedDtl.Msg,
        status: bol
          ? Settings.PayrollStatus.Approved
          : Settings.PayrollStatus.Rejected
      };
      const response = await PayrollTrialService.approvePayrollTrial(obj);
      if (response.data.IsSuccess) {
        this.$bvModal.hide("onlyApproval");
        SweetAlertService.success("Success", response.data.Message);
        this.getPayrollHdrList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async ApprOnlyDtl() {
      if (!this.AprORejBol && !this.selectedDtl.Msg) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Msg) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${
          this.AprORejBol ? t.t(dictEnum.LBL_Approve) : t.t(dictEnum.LBL_Reject)
        }`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        let staffList = [];
        let list = [];
        this.payrollTrialDetail.forEach(x => {
          list = list.concat(x.Details);
        });

        if (this.AprORejBol) {
          staffList = list
            .filter(x => x.Status == Settings.PayrollStatus.Approving)
            .map(x => x.Id);
        } else {
          let rejectList = [];
          if (this.ApproveOrRejectList.length > 0) {
            rejectList = this.ApproveOrRejectList;
          } else {
            rejectList = list
              .filter(x => x.Status == Settings.PayrollStatus.Approving)
              .map(x => x.Id);
          }
          staffList = rejectList.map(x => x.Id);
        }
        const obj = {
          staffIDs: staffList,
          txNum: this.selectedRecord.TxNum,
          remark: this.selectedDtl.Msg,
          status: this.AprORejBol
            ? Settings.PayrollStatus.Approved
            : Settings.PayrollStatus.Rejected
        };
        const response = await PayrollTrialService.approvePayrollTrial(obj);
        if (response.data.IsSuccess) {
          this.getPayrollHdrList();
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    CountAdjuctment() {
      let num = 0;
      for (const i in this.AdjustmentsList) {
        const data = this.AdjustmentsList[i];
        if (data.AdjAdd) {
          num = num + data.Amt;
        } else {
          num = num - data.Amt;
        }
      }
      return num;
    },

    sortByAdjustment(sortKey) {
      this.reverse = this.sortKey == sortKey ? !this.reverse : false;

      this.sortKey = sortKey;
    },

    showAdjustmentClick(item) {
      this.selectedDtl = item;
      this.$bvModal.show("adjustmentShow");
      this.AdjustmentTypeList = [
        {
          id: "Add",
          value: t.t(dictEnum.LBL_Addition)
        },
        {
          id: "Deduct",
          value: t.t(dictEnum.LBL_Deduct)
        },
        {
          id: "System",
          value: t.t(dictEnum.LBL_System)
        },
        {
          id: "Manual",
          value: t.t(dictEnum.LBL_Manual)
        }
      ];
      this.AdjustmentChk = this.AdjustmentTypeList.map(x => x.id);
      this.AdjustmentItemList = item.AddWages.concat(item.DeductWages);
    },

    clickSelectedItems(item) {
      const find = this.ApproveOrRejectList.find(
        x => x.StaffID == item.StaffID
      );
      if (find) {
        this.ApproveOrRejectList = this.ApproveOrRejectList.filter(
          x => x.StaffID != item.StaffID
        );
      } else {
        this.ApproveOrRejectList.push(item);
      }
    },

    clickMsg(item) {
      this.selectedMsg = item;
    },

    dbclickShowApprove(item) {
      let list = [];
      list.push(item);
      this.ApproveOrRejectList = list;
      this.$bvModal.show("ApprovalORRejectModalList");
    }
  }
};
</script>
<style scoped lang="scss">
.btn-message {
  background-color: #5ba7be;
}

.approve-tr {
  background: #d5ffd5;
}

.reject-tr {
  background: #ffa2a2;
}

.trialByDept {
  &_head {
    background-color: #d3e2e7;
    div {
      padding: 5px;
      font-size: 14px;
      font-weight: bold;
    }
  }
  &_table {
    width: max-content;
    thead {
      background-color: #f5f5f5;
      th {
        background-color: #f5f5f5;
        top: 0;
        position: sticky;
        min-width: 100px;
        color: black !important;
      }

      th:nth-child(1) {
        left: 0px;
        width: 100px;
        text-align: left;
        z-index: 10;
      }

      th:nth-child(2) {
        left: 100px;
        width: 100px;
        text-align: left;
        z-index: 10;
      }

      th:nth-child(3) {
        left: 200px;
        width: 100px;
        text-align: left;
        z-index: 10;
      }

      th:nth-child(4) {
        left: 300px;
        width: 100px;
        text-align: left;
        z-index: 10;
      }
    }
    tbody {
      background-color: white;

      td:nth-child(1) {
        position: sticky;
        left: 0px;
        width: 100px;
        text-align: left;
        background-color: white;
      }

      td:nth-child(2) {
        position: sticky;
        left: 100px;
        width: 100px;
        text-align: left;
        background-color: white;
      }

      td:nth-child(3) {
        position: sticky;
        left: 200px;
        width: 100px;
        text-align: left;
        background-color: white;
      }

      td:nth-child(4) {
        position: sticky;
        left: 300px;
        width: 100px;
        text-align: left;
        background-color: white;
      }
    }
  }
}

.popupTable {
  .head {
    background-color: #d3e2e7;
    th {
      color: black !important;
    }
  }
}

.modalMessage {
  width: 800px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/100000-Payroll/104000-PayrollApproval/PayTrialApproval/PayTrialApproval.vue